import { useTranslations } from 'next-intl';

// Tag values double as identifiers (`tag === 'sold out'`), so translate only at render.
const TAG_KEYS: Record<string, string> = {
  new: 'ring.shop.tag.new',
  popular: 'ring.shop.tag.popular',
  'sold out': 'ring.shop.soldOut',
};

export const ShopCardTagText = ({ tag }: { tag: string }) => {
  const t = useTranslations('ring');
  const key = TAG_KEYS[tag.toLowerCase()];
  return <>{key ? t(key) : tag}</>;
};
